import axios from "axios";

// Interface para padronizar as respostas
interface ApiResponse<T = any> {
  success: boolean;
  code: number;
  data: T | null;
  message: string;
  details?: any;
}

// Função auxiliar para tratar erros
const handleError = (
  error: any,
  method: string,
  route: string,
): ApiResponse => {
  const status = error.response?.status || 500;
  const data = error.response?.data || null;

  console.error(`[${method}] ${route} error:`, {
    status,
    message: error.message,
    data,
  });

  return {
    success: false,
    code: status,
    data: null,
    message: data?.message || error.message || "Erro na requisição",
    details: data?.details || null,
  };
};

export const get = async <T = any>(
  route: string,
  headers?: any,
): Promise<ApiResponse<T>> => {
  try {
    const response = await axios.get(route, { headers });
    return response.data;
  } catch (error) {
    return handleError(error, "GET", route);
  }
};

export const patch = async <T = any>(
  route: string,
  payload: any,
  headers?: any,
): Promise<ApiResponse<T>> => {
  try {
    const response = await axios.patch(route, payload, { headers });
    return response.data;
  } catch (error) {
    return handleError(error, "PATCH", route);
  }
};

export const post = async <T = any>(
  route: string,
  payload: any,
  headers?: any,
): Promise<ApiResponse<T>> => {
  try {
    const response = await axios.post(route, payload, { headers });
    return response.data;
  } catch (error) {
    return handleError(error, "POST", route);
  }
};

export const put = async <T = any>(
  route: string,
  payload: any,
  headers?: any,
): Promise<ApiResponse<T>> => {
  try {
    const response = await axios.put(route, payload, { headers });
    return response.data;
  } catch (error) {
    return handleError(error, "PUT", route);
  }
};

export const del = async <T = any>(
  route: string,
  headers?: any,
): Promise<ApiResponse<T>> => {
  try {
    const response = await axios.delete(route, { headers });
    return response.data;
  } catch (error) {
    return handleError(error, "DELETE", route);
  }
};
